import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';

const IDENTIFICATION_CODE_RESOURCE = 'addIdentificationCode';

const AddIdentificationCodeService = ComposedComponent =>
  reduxFetch([
    {
      resource: IDENTIFICATION_CODE_RESOURCE,
      method: 'post',
      request: (body, callback, t) => ({
        url: apiRoutes.identificationCodes(),
        body,
        meta: {
          callback,
          addToOtherList: {
            resource: 'identificationcode',
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'addIdentificationCodeFailed'),
            onSuccessMessage: t('addIdentificationCodeSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default AddIdentificationCodeService;
